import * as users from './actions';
import { ActionType, getType } from 'typesafe-actions';
import { UserState } from './types';

const defaultState: UserState = {
  tokens: {},
  refreshList: '',
  refreshAllList: '',
  addRemoveLoading: false,
  listLoading: false,
  loggedIn: false,
  loading: false,
  loggedInUser: {
    name: '',
    email: '',
    username: '',
    added_on: 0,
    updated_on: 0,
    bucket_count: 0,
    visited_count: 0,
    favorites_count: 0,
  },
  visitedList: [],
  favoritesList: [],
  bucketList: [],
  userParks: {},
  visited: { parks: [] },
  bucket: { parks: [] },
  favorites: { parks: [] },
  photos: {},
  username: '',
  password: '',
};

export type UserActions = ActionType<typeof users>

export default (state = defaultState, action: UserActions): UserState => {
  switch (action.type) {
    case getType(users.signoutAction):
      return {
        ...state,
        bucketList: [],
        favoritesList: [],
        visitedList: [],
        loggedInUser: {
          name: '',
          email: '',
          added_on: 0,
          updated_on: 0,
          username: '',
          visited_count: 0,
          bucket_count: 0,
          favorites_count: 0,
        },
      }
    case getType(users.setRefresh):
      return {
        ...state,
        refreshAllList: action.payload,
      }
    case getType(users.getAllListAction.request):
      return {
        ...state,
        loading: true,
      }
    case getType(users.getAllListAction.failure):
      return {
        ...state,
        loading: false,
      }
    case getType(users.getAllListAction.success):
      return {
        ...state,
        loading: false,
        refreshAllList: '',
        [`${action.payload.type}List`]: action.payload.parks,
      }
    case getType(users.updateDateAction.request):
      return {
        ...state,
        loading: true,
      }
    case getType(users.updateDateAction.failure):
      return {
        ...state,
        loading: false,
      }
    case getType(users.updateDateAction.success):
      return {
        ...state,
        loading: false,
        userParks: {
          ...state.userParks,
          [action.payload.park_code!]: {
            ...state.userParks[action.payload.park_code!],
            visited: {
              visited_on: action.payload.visited_on,
              updated_on: new Date().getTime(),
            }
          }
        },
      }
    case getType(users.addNotesAction.request):
      return {
        ...state,
        loading: true,
      }
    case getType(users.addNotesAction.failure):
      return {
        ...state,
        loading: false,
      }
    case getType(users.addNotesAction.success):
      return {
        ...state,
        loading: false,
        userParks: {
          ...state.userParks,
          [action.payload.park_code!]: {
            ...state.userParks[action.payload.park_code!],
            notes: {
              notes: action.payload.notes,
              updated_on: new Date().getTime(),
            }
          }
        },
      }
    case getType(users.removeFromUserListAction.request):
      return {
        ...state,
        addRemoveLoading: true,
      }
    case getType(users.removeFromUserListAction.failure):
      return {
        ...state,
        addRemoveLoading: false,
      }
    case getType(users.removeFromUserListAction.success):
      const { userParks } = state;
      const { parkCode, listType } = action.payload;
      delete action.payload.parkCode;
      delete action.payload.listType;
      delete userParks[parkCode!][listType!];
      // const newList = state[`${listType}List`].filter((item: string) => item !== action.payload.parkCode);
      // need to update array
      return {
        ...state,
        addRemoveLoading: false,
        refreshList: listType!,
        refreshAllList: listType!,
        loggedInUser: {
          ...state.loggedInUser,
          ...action.payload,
        },
        userParks: {
          ...userParks,
        },
        // [`${listType}List`]: newList,
      };
    case getType(users.addToUserListAction.request):
      return {
        ...state,
        addRemoveLoading: true,
      }
    case getType(users.addToUserListAction.failure):
      return {
        ...state,
        addRemoveLoading: false,
      }
    case getType(users.addToUserListAction.success):
      const { parkData } = action.payload;
      // need to update array list
      // const listName = `${action.payload.listType!}List`;
      // const newArray = JSON.parse(JSON.stringify(state[listName]));
      // newArray.push(parkData.park_code);
      return {
        ...state,
        addRemoveLoading: false,
        refreshAllList: action.payload.listType!,
        refreshList: action.payload.listType!,
        loggedInUser: {
          ...state.loggedInUser,
          ...action.payload,
        },
        userParks: {
          ...state.userParks,
          [parkData.park_code]: {
            ...state.userParks[parkData.park_code],
            [action.payload.listType!]: {
              added_on: new Date().getTime(),
            },
          },
        },
        // [action.payload.listType!]: newArray,
      }
    case getType(users.refreshTokensAction.request):
    case getType(users.getTokensFromLSAction.request):
    case getType(users.setTokensInLSAction.request):
    case getType(users.getTokensFromCodeAction.request):
      return {
        ...state,
      }
    case getType(users.getTokensFromLSAction.success):
    case getType(users.getTokensFromCodeAction.success):
      return {
        ...state,
        tokens: action.payload,
        loggedIn: true,
      }
    case getType(users.setTokensInLSAction.success):
      return {
        ...state,
        tokens: action.payload,
        loggedIn: true,
      }
    case getType(users.refreshTokensAction.success):
      return {
        ...state,
        tokens: {
          ...action.payload,
          ...state.tokens.refresh_token,
        },
        loggedIn: true,
      }
    case getType(users.getUserParkInfoAction.request):
    case getType(users.getListAction.request):
    case getType(users.getUserInfoAction.request):
      return {
        ...state,
        loading: true,
      }
    case getType(users.getUserParkInfoAction.failure):
      return {
        ...state,
        loading: false,
      }
    case getType(users.getUserParkInfoAction.success):
      const { park_code } = action.payload.park;
      return {
        ...state,
        loading: false,
        userParks: {
          ...state.userParks,
          [park_code]: action.payload.park,
        },
      }
    case getType(users.getListAction.success):
      const { type, parks, hasNextKey, photos } = action.payload;
      if (photos) {
        const photosArray = hasNextKey ? state[type].photos.concat(photos) : photos;
        return {
          ...state,
          refreshList: state.refreshList === type ? '' : state.refreshList,
          [type]: {
            nextKey: action.payload.nextKey,
            photos: photosArray,
            loaded: true,
          },
          loading: false,
        }
      }
      const parkArray = hasNextKey ? state[type].parks.concat(parks) : parks;
      return {
        ...state,
        refreshList: state.refreshList === type ? '' : state.refreshList,
        [type]: {
          nextKey: action.payload.nextKey,
          parks: parkArray,
          loaded: true,
        },
        loading: false,
      }
    case getType(users.getUserInfoAction.success):
      return {
        ...state,
        loading: false,
        loggedInUser: {
          ...state.loggedInUser,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
